import { SvgIconProps } from '@mui/material';
import { BenefitDTOBenefitEnum } from 'probonio-shared-ui/api';
import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionInterface } from 'probonio-shared-ui/registry/extension-definition';
import React from 'react';

export abstract class BenefitMetadataExtensionInterface extends ExtensionInterface {
  abstract benefitId: BenefitDTOBenefitEnum;
  abstract get Icon(): React.ComponentType<SvgIconProps>;
}

const benefitMetadataCache = new Map<BenefitDTOBenefitEnum, BenefitMetadataExtensionInterface>();
/**
 * Retrieves the metadata extension for a specific benefit type.
 * Uses caching to avoid redundant EXTENSIONS lookups.
 *
 * @param benefit - The benefit enum value (e.g., BenefitDTOBenefitEnum.Lunch)
 * @returns The matched benefit metadata extension, or undefined if none exist
 */
export function getBenefitMetadata(benefit: BenefitDTOBenefitEnum): BenefitMetadataExtensionInterface | undefined {
  if (benefitMetadataCache.has(benefit)) {
    return benefitMetadataCache.get(benefit);
  }

  const benefitMetadataProvider = EXTENSIONS.getProviders(BenefitMetadataExtensionInterface).find(({ benefitId }) => benefitId === benefit);

  if (!benefitMetadataProvider) {
    return undefined;
  }

  benefitMetadataCache.set(benefit, benefitMetadataProvider);

  return benefitMetadataProvider;
}
